import type { VideoWallPageLayoutState } from '../../types';

export function isEpisodeSectionVisible(state: VideoWallPageLayoutState): boolean {
  return ['videowall-and-episodes', 'videowall-with-episodes-and-sidebar'].includes(state);
}

export function isSidebarSectionVisible(state: VideoWallPageLayoutState): boolean {
  return ['videowall-and-sidebar', 'videowall-with-episodes-and-sidebar'].includes(state);
}
